const paths = {
  consoleReportMonitoringCenter: '/reportConsole'
};

export default paths;
